import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import store from '@/store'
import { safeXLogSend } from '@/common/utils/xLogManager';
Vue.use(VueRouter)

const lazyLoad = (view: string) => () => import(/* webpackChunkName: "[request]" */ `../views/${view}.vue`);

const routes: Array<RouteConfig> = [
	{
		path: '/health',
		name: 'health',
		component: () => import('../views/health.vue'),
		meta: { title: 'EBooking健康检查' },
	},
	{
		path: '/abnormalLogin',
		name: 'abnormalLogin',
		component: lazyLoad('AbnormalLogin'),
		meta: { title: '携程账户登录' },
	},
	{
		path: '/dkbHome',
		name: 'dkbHome',
		component: lazyLoad('home/index'),
		meta: { title: 'EBooking首页' },
	},
	{
		path: '/letterOfConfirmation',
		name: 'letterOfConfirmation',
		component: lazyLoad('home/LetterOfConfirmation'),
		meta: { title: '推广房型确认书页' },
	},
	{
		path: '/redPacket',
		name: 'redPacket',
		component: lazyLoad('redPackage/index'),
		meta: { title: 'EBooking红包页面' },
	},
	{
		path: '/exchangeFundDetail',
		name: 'exchangeFundDetail',
		component: lazyLoad('redPackage/ExchangeFundDetail'),
		meta: { title: 'EBooking兑换金明细页面' },
	},
	{
		path: '/smzHotelData',
		name: 'smzHotelData',
		component: lazyLoad('redPackage/SmzHotelData'),
		meta: { title: 'EBooking扫码住酒店数据页面' },
	},
	{
		path: '/cpsCreate',
		name: 'cpsCreate',
		component: lazyLoad('cps/CpsCreate'),
		meta: { title: 'EBookingCPS创建页面' },
	},
	{
		path: '/cpsList',
		name: 'cpsList',
		component: lazyLoad('cps/CpsList'),
		meta: { title: 'EBookingCPS列表页面' },
	},
	{
		path: '/cpsDeatil',
		name: 'cpsDeatil',
		component: lazyLoad('cps/CpsDeatil'),
		meta: { title: 'EBookingCPS详情页面' },
	},
	{
		path: '/cpsSettlement',
		name: 'cpsSettlement',
		component: lazyLoad('cps/CpsSettlement'),
		meta: { title: 'EBookingCPS财务结算页面' },
	},
	{
		path: '/cpsContact',
		name: 'cpsContact',
		component: lazyLoad('cps/CpsContact'),
		meta: { title: 'EBookingCPS咨询页面' },
	},
	{
		path: '/cpsSettlementLog',
		name: 'cpsSettlementLog',
		component: lazyLoad('cps/CpsSettlementLog'),
		meta: { title: 'EBookingCPS发票上次日志页面' },
	},
	{
		path: '/cpsSettlementDetail',
		name: 'cpsSettlementDetail',
		component: lazyLoad('cps/CpsSettlementDetail'),
		meta: { title: 'EBookingCPS账单明细页面' },
	},
	{
		path: '/cpsSyjProductIntroduce',
		name: 'cpsSyjProductIntroduce',
		component: lazyLoad('cps/CpsSyjProductIntroduce'),
		meta: { title: 'EBookingCPS生意金产品介绍页面' },
	},
	{
		path: '/marketIntroduction',
		name: 'marketIntroduction',
		component: lazyLoad('market/MarketIntroduction'),
		meta: { title: 'EBooking精准营销说明页面' },
	},
	{
		path: '/marketList',
		name: 'marketList',
		component: lazyLoad('market/MarketList'),
		meta: { title: 'EBooking精准营销列表页面' },
	},
	{
		path: '/marketCentre',
		name: 'marketCentre',
		component: lazyLoad('market/MarketCentre'),
		meta: { title: 'EBooking精准营销中心页面' },
	},
	{
		path: '/marketCreate',
		name: 'marketCreate',
		component: lazyLoad('market/MarketCreate'),
		meta: { title: 'EBooking精准营销创建页面' },
	},
	{
		path: '/marketLog',
		name: 'marketLog',
		component: lazyLoad('market/MarketLog'),
		meta: { title: 'EBooking精准营销日志列表页面' },
	},
	{
		path: '/marketDetail',
		name: 'marketDetail',
		component: lazyLoad('market/MarketDetail'),
		meta: { title: 'EBooking精准营销详情页面' },
	},
	{
		path: '/invoiceList',
		name: 'invoiceList',
		component: lazyLoad('invoice/InvoiceList'),
		meta: { title: 'EBooking发票列表页面' },
	},
	{
		path: '/invoiceHistory',
		name: 'invoiceHistory',
		component: lazyLoad('invoice/InvoiceHistory'),
		meta: { title: 'EBooking开票历史列表页面' },
	},
	{
		path: '/invoiceDetail',
		name: 'invoiceDetail',
		component: lazyLoad('invoice/InvoiceDetail'),
		meta: { title: 'EBooking发票详情页面' },
	},
	{
		path: '/invoiceCreate',
		name: 'invoiceCreate',
		component: lazyLoad('invoice/InvoiceCreate'),
		meta: { title: 'EBooking发票创建页面' },
	},
	{
		path: '/virtualCurrencyHome',
		name: 'virtualCurrencyHome',
		component: lazyLoad('virtualCurrency/VirtualCurrencyHome'),
		meta: { title: 'EBooking带客金首页' },
	},
	{
		path: '/virtualCurrencyAgreement',
		name: 'virtualCurrencyAgreement',
		component: lazyLoad('virtualCurrency/VirtualCurrencyAgreement'),
		meta: { title: 'EBooking带客金推广合作协议页面' },
	},
	{
		path: '/virtualCurrencySetting',
		name: 'virtualCurrencySetting',
		component: lazyLoad('virtualCurrency/VirtualCurrencySetting'),
		meta: { title: 'EBooking带客金设置页面' },
	},
	{
		path: '/excellentCase',
		name: 'excellentCase',
		component: lazyLoad('virtualCurrency/ExcellentCase'),
		meta: { title: 'EBooking带客金优秀案例页面' },
	},
	{
		path: '/virtualCurrencyWallet',
		name: 'virtualCurrencyWallet',
		component: lazyLoad('virtualCurrency/VirtualCurrencyWallet'),
		meta: { title: 'EBooking带客金钱包明细页面' },
	},
	{
		path: '/virtualCurrencyGameplay',
		name: 'virtualCurrencyGameplay',
		component: lazyLoad('virtualCurrency/VirtualCurrencyGameplay'),
		meta: { title: 'EBooking带客金玩法介绍页面' },
	},
	{
		path: '/walletReplacementRoom',
		name: 'walletReplacementRoom',
		component: lazyLoad('wallet/WalletReplacementRoom'),
		meta: { title: 'EBooking生意金充值费率设置详情页面' },
	},
	{
		path: '/editWalletReplacementRoom',
		name: 'editWalletReplacementRoom',
		component: lazyLoad('wallet/EditWalletReplacementRoom'),
		meta: { title: 'EBooking生意金充值费率设置编辑页面' },
	},
	{
		path: '/cooperationAgreement',
		name: 'cooperationAgreement',
		component: lazyLoad('wallet/Cooperationagreement'),
		meta: { title: 'EBooking预付款协议页面' },
	},
	{
		path: '/walletLogList',
		name: 'walletLogList',
		component: lazyLoad('wallet/WalletLogList'),
		meta: { title: 'EBooking生意金页面' },
	},
	{
		path: '/prePayment',
		name: 'prePayment',
		component: lazyLoad('wallet/PrePayment'),
		meta: { title: 'EBooking充值预付页面' },
	},
	{
		path: '/wallet',
		name: 'wallet',
		component: lazyLoad('wallet/Wallet'),
		meta: { title: 'EBooking钱包页面' },
	},
	{
		path: '/extensionCenter',
		name: 'extensionCenter',
		component: lazyLoad('extension/ExtensionCenter'),
		meta: { title: 'EBooking推广中心页面' },
	},
	{
		path: '/dataReport',
		name: 'dataReport',
		component: lazyLoad('extension/DataReport'),
		meta: { title: 'EBooking数据报告页面' },
	},
	{
		path: '/extensionMine',
		name: 'extensionMine',
		component: lazyLoad('extension/ExtensionMine'),
		meta: { title: 'EBooking我的推广页面' },
	},
	{
		path: '/cpcTrafficExpressLog',
		name: 'cpcTrafficExpressLog',
		component: lazyLoad('extension/CpcTrafficExpressLog'),
		meta: { title: 'EBooking推广日志页面' },
	},
	{
		path: '/promotionStrategy',
		name: 'promotionStrategy',
		component: lazyLoad('extension/PrmomtionStrategy'),
		meta: { title: 'EBooking流量快车CPC推广攻略页面' },
	},
	{
		path: '/questionCenter',
		name: 'QuestionCenter',
		component: lazyLoad('extension/QuestionCenter'),
		meta: { title: 'EBooking产品简介页面' },
	},
	{
		path: '/cpcDiagnosticTool',
		name: 'CpcDiagnosticTool',
		component: lazyLoad('extension/CpcDiagnosticTool'),
		meta: { title: 'EBooking投放诊断工具页面' },
	},
	{
		path: '/subscribe',
		name: 'Subscribe',
		component: lazyLoad('extension/Subscribe'),
		meta: { title: 'EBooking白名单/消息订阅设置页面' },
	},
	{
		path: '/createSearchPromotion',
		name: 'createSearchPromotion',
		component: lazyLoad('searchPromotionNew/index'),
		meta: { title: 'EBooking创建推广计划页面' },
	},
	{
		path: '/cpcPromotionProtocol',
		name: 'cpcPromotionProtocol',
		component: lazyLoad('searchPromotion/components/CpcPromotionProtocol'),
		meta: { title: 'EBooking推广合作协议页面' },
	},
	{
		path: '/brandAdvertisement',
		name: 'brandAdvertisement',
		component: lazyLoad('servicePromotion/brandAdvertisement'),
		meta: { title: 'EBooking品牌广告创建页面' },
	},
	{
		path: '/intelligenceRecommend',
		name: 'intelligenceRecommend',
		component: lazyLoad('servicePromotion/intelligenceRecommend'),
		meta: { title: 'EBooking智能推荐创建页面' },
	},
	{
		path: '/cptSimilarHotelCreate',
		name: 'cptSimilarHotelCreate',
		component: lazyLoad('servicePromotion/cptSimilarHotelCreate'),
		meta: { title: 'EBooking相似酒店推荐创建页面' },
	},
	{
		path: '/cptWeChatMasterCreate',
		name: 'cptWeChatMasterCreate',
		component: lazyLoad('servicePromotion/cptWeChatMasterCreate'),
		meta: { title: 'EBooking微信达人创建页面' },
	},
	{
		path: '/cptDecorateCreate',
		name: 'cptDecorateCreate',
		component: lazyLoad('servicePromotion/cptDecorateCreate'),
		meta: { title: 'EBooking程艺推荐创建页面' },
	},
	{
		path: '/cptMarketActivity',
		name: 'cptMarketActivity',
		component: lazyLoad('servicePromotion/cptMarketActivity'),
		meta: { title: 'EBooking市场活动创建页面' },
	},
	{
		path: '/otaPayDetail',
		name: 'otaPayDetail',
		component: lazyLoad('wallet/OtaPayDetail'),
		meta: { title: '代运营支付单记录明细列表' },
	},
	{
		path: '/cptOrderDetail',
		name: 'cptOrderDetail',
		component: lazyLoad('servicePromotion/cptOrderDetail'),
		meta: { title: 'EBookingCPT订单详情页面' },
	},
	{
		path: '/cptDataReport',
		name: 'cptDataReport',
		component: lazyLoad('servicePromotion/cptDataReport'),
		meta: { title: 'EBookingCPT数据分析页面' },
	},
	{
		path: '/cptTrafficDataReport',
		name: 'cptTrafficDataReport',
		component: lazyLoad('servicePromotion/cptTrafficDataReport'),
		meta: { title: 'EBooking流量快车分析页面' },
	},
	{
		path: '/servicePromotionList',
		name: 'servicePromotionList',
		component: lazyLoad('servicePromotion/servicePromotionList'),
		meta: { title: 'EBookingCPT推广列表页面' },
	},
	{
		path: '/peakDayCascader',
		name: 'peakDayCascader',
		component: lazyLoad('peakDay/PeakDayCascader'),
		meta: { title: 'EBooking高峰日日历页面' },
	},
	{
		path: '/noticeCenter',
		name: 'noticeCenter',
		component: lazyLoad('adNotice/noticeCenter'),
		meta: { title: 'EBooking通知中心列表页面' },
	},
	{
		path: '/noticeDetails',
		name: 'noticeDetails',
		component: lazyLoad('adNotice/noticeDetails'),
		meta: { title: 'EBooking通知中心详情页面' },
	},
	{
		path: '/serviceProviderInformation',
		name: 'serviceProviderInformation',
		component: lazyLoad('serviceProviderInformation/index'),
		meta: { title: 'EBooking全国服务商概览页面' },
	},
	{
		path: '/bindingAgreement',
		name: 'bindingAgreement',
		component: lazyLoad('extension/BindingAgreement'),
		meta: { title: 'EBooking合作协议页面' },
	},
	{
		path: '/finishUrl',
		name: 'finishUrl',
		component: lazyLoad('adPay/finishUrl'),
		meta: { title: 'EBooking支付结果页面' },
	},
	{
		path: '/explorerInterceptDesc',
		name: 'explorerInterceptDesc',
		component: lazyLoad('explorerInterceptDesc/index'),
		meta: { title: 'EBooking支付浏览器拦截说明页面' },
	},
	{
		path: '/attractCustomersStrategy',
		name: 'attractCustomersStrategy',
		component: lazyLoad('home/attractCustomersStrategy'),
		meta: { title: 'EBooking流量快车CPC推广攻略页面' },
	},
	{
		path: '/cpmDesc',
		name: 'cpmDesc',
		component: lazyLoad('home/cpmDesc'),
		meta: { title: 'EBooking流量加油站CPM推广攻略页面' },

	},
	// 数据报告->详情
	{
		path: '/orderReportDetail',
		name: 'orderReportDetail',
		component: lazyLoad('extension/OrderReportDetail'),
		meta: { title: 'EBooking数据报告详情页面' },
	},
	// 活动弹窗详情
	{
		path: '/activityPopDetail',
		name: 'activityPopDetail',
		component: lazyLoad('activityPopDetail/index'),
		meta: { title: 'EBooking活动弹窗页面' },
	},
	{
		path: '/insuranceDetail',
		name: 'insuranceDetail',
		component: lazyLoad('insurance/InsuranceDetail'),
		meta: { title: 'EBooking保效投放详情页面' },
	},
]
console.log('process.env.VUE_APP_ROUTER_BASE', process.env.VUE_APP_ROUTER_BASE)
const router = new VueRouter({
	mode: 'history',
	base: process.env.VUE_APP_ROUTER_BASE,
	routes,
})
console.log('Router base:', router.options.base);


// 获取 Cookie 的值
const getCookie = (cname: string) => {
	let name = cname + '=';
	let ca = document.cookie.split(';');
	for (let i = 0; i < ca.length; i++) {
		let c = ca[i].trim();
		if (c?.indexOf(name) === 0) {
			return c.substring(name.length, c.length);
		}
	}
	return '';
}

// 设置 Cookie 的值
const setCookie = (cname: string, cvalue: string, exdays: number) => {
	const d = new Date();
	d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
	const expires = 'expires=' + d.toUTCString();
	document.cookie = `${cname}=${cvalue}; ${expires}; path=/; SameSite=None; Secure`;
};

const EbkSessionId = getCookie('EbkSessionId')
let SessionToken = getCookie('SessionToken')
let H5CookieId = getCookie('H5CookieId')

router.beforeEach((to, from, next) => {
	if (document) {
		document.title = to?.meta?.title || 'EBooking页面'
	}

	if (store) {
		if (!(window as any)._xlogUser) {
			try {
				(window as any)._xlogUser = store.state.mhotelName + store.state.mhotelId
				console.log('_xlogUser', (window as any)._xlogUser);
			} catch (error) {
				console.log('error:', error);
			}
		}

		safeXLogSend(
			'view',
			{
				key_TcUserId: store.state.userNumber || '',
				key_mhotelId: store.state.mhotelId || '',
				key_shotelId: store.state.shotelId || '',
				key_referrerChannel: store.state.isHeCheng ? '携程EBooking' : '同程EBooking',
				key_plateform: 'e_booking_pc',
				key_pageUrl: to?.path,
			}
		);

		if (
			(SessionToken !== EbkSessionId) ||
			(H5CookieId && H5CookieId !== store?.state?.mhotelId)
		) {
			setCookie('SessionToken', EbkSessionId, 7);
			setCookie('H5CookieId', store?.state?.mhotelId, 7);
			SessionToken = EbkSessionId;
			H5CookieId = store?.state?.mhotelId;
		}
	}
	next();
});
export default router